// extracted by mini-css-extract-plugin
export default {"intro--imageWrap":"NewsPage--intro--imageWrap--2cKVW"};